// extracted by mini-css-extract-plugin
export default {"previewBlock":"PreviewBlock_previewBlock__kUSBU"};